import type { ModuleStatus } from "../types";
import type { SiteRecord } from "./types";

/**
 * Site's status on the sidebar, the overview and project cards: what is true of the project's site now, in words.
 * Nothing here says "loading"; the surroundings are not read yet (PRD 11 §5.4, Phase 2).
 */
export const SITE_STATUS = {
  none: "Add location",
  located: "Location set",
  bounded: "Boundary set",
} as const;

/** What is known of a site: its record when read, else only whether the project has an address. */
export interface SiteFacts {
  readonly record?: SiteRecord | undefined;
  readonly hasAddress: boolean;
}

/** "Boundary set" once a plot has a boundary, "Location set" once there is a pin or an address, else "Add location". */
export function siteStatus({ record, hasAddress }: SiteFacts): ModuleStatus {
  if (record?.plots.some((plot) => plot.boundary !== undefined) === true)
    return { module: "site", label: SITE_STATUS.bounded, tone: "pass" };
  if (record?.location !== undefined || hasAddress)
    return { module: "site", label: SITE_STATUS.located, tone: "neutral" };
  return { module: "site", label: SITE_STATUS.none, tone: "neutral" };
}
